export const DASHBOARD_MAX_LEADERBOARD_ROWS = 500;
export const LIVEPOLL_FINISHED_MAX_LEADERBOARD_ROWS = 500;
export const QUESTION_FINISHED_MAX_LEADERBOARD_ROWS = 100;
